import Repository from "../Repository";

const resource = "/predict";
export default {
    getSites() {
        return Repository.get(`${resource}`);
    } ,
    getSitePrediction(name,limit,noFp) {
        if(limit&&noFp){
            return Repository.get(`${resource}/${name}/${limit}/${noFp}/true`);
        }else if(limit){
            return Repository.get(`${resource}/${name}/${limit}/false/true`);
        }else{
            return Repository.get(`${resource}/${name}/false/false/true`);
        }

    }
}